import { c as _c } from "react/compiler-runtime";
import { EntityRepository } from '@record-it-npm/synchro-client';
import { useCallback, useEffect, useState } from 'react';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../../classes/entities/AppEntityManagerEntityTypesByEntityName';
import { useEntityRepository } from './useEntityRepository';
export function useEntityByIdOrOriginalId(entityName, idOrOriginalId) {
  const $ = _c(6);
  const repository = useEntityRepository(entityName) as EntityRepository<any, any, any>;
  let t0;
  if ($[0] !== idOrOriginalId || $[1] !== repository) {
    t0 = () => {
      let entry = null;
      if (idOrOriginalId) {
        entry = repository.getById(idOrOriginalId);
        if (!entry) {
          entry = repository.getByOriginalId(idOrOriginalId);
        }
      }
      return entry;
    };
    $[0] = idOrOriginalId;
    $[1] = repository;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const queryEntity = t0;
  const [entity, setEntity] = useState(queryEntity);
  let t1;
  let t2;
  if ($[3] !== queryEntity) {
    t1 = () => {
      setEntity(queryEntity);
    };
    t2 = [queryEntity];
    $[3] = queryEntity;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  return entity;
}